import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root'
})
export class CmsContentService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { }

  getCustomerServiceInfo() {
    return this.http.get<any>( this.configService.customerServiceapiUri + '/contactus/customerserviceinfo');
}
  getUhcsrCmsContentByType(id: string, type: string) {
      return this.http.get<any>(this.configService.apiUri + `/api/cms/content/uhcsr/` + id + '?type=' + type);
  }

  getMyAccountCmsContentByType(id: string, type: string) {
    return this.http.get<any>(this.configService.apiUri + `/api/cms/content/myaccount/` + id + '?type=' + type);
  }
}
